import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Bank = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="bank icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M22 7.98198H22.8561C23.9329 7.98198 24.2491 6.51379 23.2677 6.0706L12.4116 1.16785C12.1499 1.04968 11.8501 1.04968 11.5884 1.16785L0.732349 6.0706C-0.248998 6.51379 0.0671533 7.98198 1.14393 7.98198H2.00003V8.98198H22V7.98198Z"
    />
    <path
      className={pathClass}
      d="M8.00003 10.982H11V19.982H13V10.982H16V19.982H18V10.982H21V19.982H21.5C22.3285 19.982 23 20.6535 23 21.482C23 22.3104 22.3285 22.982 21.5 22.982H2.50003C1.6716 22.982 1.00003 22.3104 1.00003 21.482C1.00003 20.6535 1.6716 19.982 2.50003 19.982H3.00003V10.982H6.00003V19.982H8.00003V10.982Z"
    />
  </svg>
)
